<template>
  <div class="container mt-85">
    <div class="wrapper-merci center-align col l12">
      <h4 class="center-align">
        <span class="fw-400 fs-12 center-align" v-html="textErreur[messageKey]"></span>
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "emailValidation",
  props: {
    textErreur: {
      type: Object,
      required: true
    },
    messageKey: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.mt-85 {
  margin-top: 75px !important;
}
.wrapper-merci {
  min-height: 250px;
  h4 {
  }
  .fs-12 {
    font-size: 30px;
  }
}
</style>
